/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Orders_NoteInputs */

const vi_shop_account_orders_note = /** @type {(inputs: Shop_Account_Orders_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hạng và chi tiêu ở danh sách cập nhật mỗi đêm; mở chi tiết tài khoản để xem số mới nhất.`)
};

/**

* @param {Shop_Account_Orders_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_orders_note = /** @type {((inputs?: Shop_Account_Orders_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Orders_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_orders_note(inputs)
});